var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.featuresBand'] = (function () {
    'use strict';

    const CONFIG = {
        FEATURE_SELECTOR: '.block-features-band__feature',
        FEATURE_ANIMATION: 'animate__fadeInUp',
        FEATURE_STAGGER: 150
    };

    const initialize = (block) => {
        if (!block || !block.id) return;

        if (block.querySelectorAll(CONFIG.FEATURE_SELECTOR).length === 0) return;

        App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, {
            targets: [
                { selector: CONFIG.FEATURE_SELECTOR, type: CONFIG.FEATURE_ANIMATION, stagger: CONFIG.FEATURE_STAGGER }
            ]
        });
    };

    return {
        initialize
    };

})();
